// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {isFeatureEnabled} from '@github-ui/feature-flags'

import ImageAzureDataStudio from './../../assets/images/ide-icons/azure.svg'
import ImageEclipse from './../../assets/images/ide-icons/eclipse.svg'
import ImageGitHubBlack from './../../assets/images/ide-icons/github-black.svg'
import ImageGitHubWhite from './../../assets/images/ide-icons/github-white.svg'
import ImageJetBrains from './../../assets/images/ide-icons/jetbrains.svg'
import ImageNeovim from './../../assets/images/ide-icons/neovim.svg'
import ImageRaycast from './../../assets/images/ide-icons/raycast.svg'
import ImageVisualStudio from './../../assets/images/ide-icons/visualstudio.svg'
import ImageVSCode from './../../assets/images/ide-icons/vscode.svg'
import ImageXcode from './../../assets/images/ide-icons/xcode.svg'
import type {IdeListItemProps} from './IdeListItem/IdeListItem'

export const getIdeData = (excludeList: Array<IdeListItemProps['id']> = []) => {
  const data: Array<Omit<IdeListItemProps, 'size' | 'onClick' | 'isListItem'>> = [
    {
      id: 'github',
      name: 'GitHub',
      href: 'https://github.com/copilot',
      image: {light: ImageGitHubBlack, dark: ImageGitHubWhite},
    },
    {
      id: 'vscode',
      name: 'VS Code',
      href: 'https://marketplace.visualstudio.com/items?itemName=GitHub.copilot-chat',
      image: ImageVSCode,
    },
    {
      id: 'vs',
      name: 'Visual Studio',
      href: 'https://visualstudio.microsoft.com/github-copilot',
      image: ImageVisualStudio,
    },
    {
      id: 'xcode',
      name: 'Xcode',
      href: 'https://github.com/github/CopilotForXcode',
      image: ImageXcode,
    },
    {
      id: 'jetbrains',
      name: 'JetBrains',
      appendix: 'IDEs',
      href: 'https://plugins.jetbrains.com/plugin/17718-github-copilot',
      image: ImageJetBrains,
    },
    {
      id: 'neovim',
      name: 'Neovim',
      href: 'https://github.com/github/copilot.vim',
      image: ImageNeovim,
    },
    {
      id: 'azuredatastudio',
      name: 'Azure',
      appendix: 'Data Studio',
      href: 'https://learn.microsoft.com/en-us/azure-data-studio/extensions/github-copilot-extension-overview',
      image: ImageAzureDataStudio,
    },
    {
      id: 'eclipse',
      name: 'Eclipse',
      href: 'https://marketplace.eclipse.org/content/github-copilot#details',
      image: ImageEclipse,
    },
    // Conditionally include Raycast based on feature flag
    ...(isFeatureEnabled('copilot_features_raycast_logo')
      ? [
          {
            id: 'raycast' as const,
            name: 'Raycast',
            href: 'https://gh.io/copilot-raycast-docs',
            image: ImageRaycast,
          },
        ]
      : []),
  ]

  return data.filter(ide => !excludeList.includes(ide.id))
}
